<div class="text">
	@if (entry.labelTranslate) {
		<h3 [ngClass]="entry.labelClasses" [translate]="entry.labelTranslate"></h3>
	}
	@if (!entry.labelTranslate) {
		<h3 [ngClass]="entry.labelClasses">{{ entry.label }}</h3>
	}
	<div class="info">
		@if (!entry.secondLineTranslate) {
			<h6>{{ entry.secondLine }}</h6>
		}
		@if (entry.secondLineTranslate) {
			<h6 translate="{{ entry.secondLineTranslate }}"></h6>
		}
		<div class="ico-size" [ngClass]="iconClass">
			<i class="ico"></i>
			<i class="ico"></i>
			<i class="ico"></i>
		</div>
	</div>
</div>
